import { render, staticRenderFns } from "./CarrierStatus.vue?vue&type=template&id=bb804dfe"
import script from "./CarrierStatus.vue?vue&type=script&lang=js"
export * from "./CarrierStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports